/** Dossier Compás: Client Info | Producción | Presentaciones PDF | Status. */

export const CLIENT_INFO_KINDS = Object.freeze([
  "client_info",
  "produccion",
  "presentaciones_pdf",
  "status",
]);

export function normalizeClientInfoKind(raw, { fallback = "client_info" } = {}) {
  const v = String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  if (v === "produccion" || v === "production" || v === "prod") {
    return "produccion";
  }
  if (
    v === "presentaciones_pdf" ||
    v === "presentacion" ||
    v === "presentaciones" ||
    v === "presentation" ||
    v === "presentations_pdf" ||
    v === "presentacion_pdf"
  ) {
    return "presentaciones_pdf";
  }
  if (v === "status" || v === "statuses" || v === "estado") {
    return "status";
  }
  if (v === "client_info" || v === "clientinfo" || v === "info") {
    return "client_info";
  }
  const fb = String(fallback || "client_info")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  if (fb === "produccion" || fb === "production" || fb === "prod") {
    return "produccion";
  }
  if (
    fb === "presentaciones_pdf" ||
    fb === "presentacion" ||
    fb === "presentaciones" ||
    fb === "presentation"
  ) {
    return "presentaciones_pdf";
  }
  if (fb === "status" || fb === "statuses" || fb === "estado") {
    return "status";
  }
  return "client_info";
}

export function isProduccionRow(row) {
  return normalizeClientInfoKind(row?.Kind || row?.kind) === "produccion";
}

export function isPresentacionesRow(row) {
  return (
    normalizeClientInfoKind(row?.Kind || row?.kind) === "presentaciones_pdf"
  );
}

export function isStatusRow(row) {
  return normalizeClientInfoKind(row?.Kind || row?.kind) === "status";
}

export function isClientInfoRow(row) {
  return normalizeClientInfoKind(row?.Kind || row?.kind) === "client_info";
}

export function folderKeyForClientInfoKind(kind) {
  const k = normalizeClientInfoKind(kind);
  if (k === "produccion") return "produccion";
  if (k === "presentaciones_pdf") return "presentaciones";
  if (k === "status") return "status";
  return "info";
}

export function defaultTituloForKind(kind) {
  const k = normalizeClientInfoKind(kind);
  if (k === "produccion") return "Producción";
  if (k === "presentaciones_pdf") return "Presentaciones PDF";
  if (k === "status") return "Status";
  return "Client Info";
}
